<template>
   <Dialog :visible="showDialog" modal
   :style="{ width: '50rem' }" class="mx-2 sm:mx-4 black-bg personal-goal-feedback-dialog">
    <template #header>
      <div class="inline-flex items-center justify-center gap-2 flex-wrap text-center">
        <font-awesome-icon class="text-xl sm:text-2xl text-[var(--color-orange)] shrink-0"
          icon="fa-regular fa-lightbulb"/>
        <span class="font-bold text-base sm:text-xl break-words">
          {{ $t('PersonalGoalFeedbackOverlayComponent.yourFeedback') }}
        </span>
      </div>
    </template>
    <form action="#" class="px-0 sm:px-1">
      <div class="flex flex-start my-2 mx-0 sm:mx-2">
        <p class="text-sm sm:text-base">{{ $t('PersonalGoalFeedbackOverlayComponent.howDoYouFeel') }}</p>
      </div>
      <Textarea v-model="text" maxlength="5000" class="text-sm sm:text-base h-32 sm:h-40 w-full max-w-full"
          :placeholder="$t('PersonalGoalFeedbackOverlayComponent.placeholderText')"></Textarea>
      <div class="flex justify-end mt-4">
        <Button class="btn-primary-accent w-full sm:w-auto h-10 px-4 text-sm sm:text-base" unstyled
          :disabled="buttonDisabled"
          @click.prevent="submitFeedback">
          {{ $t('PersonalGoalFeedbackOverlayComponent.sendFeedback') }}
        </Button>
      </div>
    </form>
  </Dialog>
</template>

<script>
import { Dialog, Textarea, Button } from 'primevue';

export default {
  name: 'PersonalGoalFeedbackOverlayComponent',
  props: {
    data: Object,
    showDialog: Boolean,
  },
  components: { Dialog, Textarea, Button },
  data() {
    return {
      text: '',
      buttonDisabled: false,
    };
  },
  mounted() {
    this.scrollToElement();
  },
  methods: {
    async submitFeedback() {
      try {
        this.buttonDisabled = true;
        await this.$store.dispatch('submitPersonalGoalFeedback', {
          id: this.data.goalId,
          feedback_text: this.text.trim(),
        });
        this.buttonDisabled = false;
        // this.$store.commit('removeFrontendOverlay', this.data.id);
      } catch (error) {
        this.buttonDisabled = false;
        this.$toast.add({
          severity: 'error',
          summary: this.$t('PersonalGoalFeedbackOverlayComponent.errorCouldNotFeedback'),
          detail: '',
          life: 3000,
        });
      } finally {
        this.$emit('update:visible', false);
        this.$emit('confirmed');
      }
    },
    closePopup() {
      // this.$store.commit('removeFrontendOverlay', this.data.id);
      this.$emit('update:visible', false);
      this.$emit('confirmed');
    },
    scrollToElement() {
      const el = this.$refs.goalel;
      if (el && typeof el.scrollIntoView === 'function') {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 640px) {
  :deep(.p-dialog) {
    width: calc(100vw - 1rem) !important;
    max-width: calc(100vw - 1rem);
  }
}
</style>
